import React from "react";
import { Link } from "react-router-dom"; // 1. Import the Link component

export function NavbarLogo({ href }) { // 2. Accept the href prop
  return (
    // 3. Wrap everything in a Link component
    <Link to={href} className="flex items-center space-x-2">
      <img
        src="/image (2).png"
        alt="Pure-AI Logo" // It's good practice to have descriptive alt text
        width={50}
        height={30}
        className="h-auto"
      />
      <span className="text-lg font-semibold">
        <span className="text-blue-500">PURE</span><span className="text-white">-AI</span>
      </span>
    </Link>
  );
}